import tccf7EventManager from './tccf7EventManager.js';
import { TCCF7_CONFIG } from './tccf7Constants.js';

/*-------------------------------------------------------------------------------

  送信完了画面

--------------------------------------------------------------------------------*/

export default class tccf7Complete {
  constructor( formId ) {
    this.formId = formId;
    this.start  = false;

    const configKey = `${TCCF7_CONFIG.KEY.COMPLETE}_${this.formId}`;
    this.complete = window[configKey] || false;
    if( !this.complete ) return;

    this.url = this.complete[TCCF7_CONFIG.TARGET.THANKS] ?? false;
    if( !this.url ) return;
    
    this.eventManager = tccf7EventManager.getInstance(this.formId);
    
    this.init();
  }

  init() {
    const currentDomain = window.location.origin;
    const thanksDomain = new URL(this.url, currentDomain).origin;
    if(currentDomain === thanksDomain){
      this.start = true;
      this.redirect();
    }
  }

  redirect() {
    const url = this.url;
    this.eventManager.on('mailsent', () => {
      location.href = url;
    });
  }
}